
import { frodoMediaArray } from './frodoMedia'
import { hollyReviewerProfile, luigiReviewerProfile, gatsbyReviewerProfile } from './frodoReviewers'
import { frodoBio, hollyBio, luigiBio, gatsbyBio } from './frodoBios'
import { frodoDatingProfileHinge, frodoDatingProfileBumble, frodoDatingProfileTinder } from './frodoDatingProfiles'

export const frodoUser = {
  _id: 'frodoUserId',
  email: 'frodo@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...hollyReviewerProfile },
    { ...luigiReviewerProfile },
    { ...gatsbyReviewerProfile }
  ],
  media: [ ...frodoMediaArray ],
  bio: { ...frodoBio },
  datingProfiles: [
    { ...frodoDatingProfileHinge },
    { ...frodoDatingProfileBumble },
    { ...frodoDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const hollyUser = {
  _id: 'hollyUserId',
  email: 'holly@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...hollyBio },
  datingProfiles: [],
  reviewerProfile: { ...hollyReviewerProfile },
}

export const luigiUser = {
  _id: 'luigiUserId',
  email: 'luigi@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...luigiBio },
  datingProfiles: [],
  reviewerProfile: { ...luigiReviewerProfile },
}

export const gatsbyUser = {
  _id: 'gatsbyUserId',
  email: 'gatsby@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...gatsbyBio },
  datingProfiles: [],
  reviewerProfile: { ...gatsbyReviewerProfile },
}
